// extracted by mini-css-extract-plugin
module.exports = {"emphasis":"FutureEstimate__emphasis___V3wDa","editable":"FutureEstimate__editable___c-4Zs"};